import { PartialType } from '../../../../utils';
import { CreateDailyExcessInsuranceFeeDto } from './create-daily-excess-insurance-fee.dto';
export class UpdateDailyExcessInsuranceFeeDto extends PartialType(CreateDailyExcessInsuranceFeeDto) {
}
